export const languages = ['en', 'es'];

export const defaultLanguage = 'en';
